import { Chip } from '@mui/material';

const statusColors: Record<string, 'default' | 'info' | 'warning' | 'success'> = {
  open: 'info',
  in_progress: 'warning',
  waiting_user: 'default',
  closed: 'success'
};

const statusLabels: Record<string, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  waiting_user: 'Waiting User',
  closed: 'Closed'
};

interface StatusChipProps {
  record?: any;
  source: string;
}

export const StatusChip = ({ record, source }: StatusChipProps) => {
  const status = record?.[source];
  if (!status) return null;

  return (
    <Chip
      label={statusLabels[status] || status}
      color={statusColors[status] || 'default'}
      size="small"
    />
  );
};
